import { render, staticRenderFns } from "./TournamentScheduleTable.vue?vue&type=template&id=0b27d398&scoped=true"
import script from "./TournamentScheduleTable.vue?vue&type=script&lang=js"
export * from "./TournamentScheduleTable.vue?vue&type=script&lang=js"
import style0 from "./TournamentScheduleTable.vue?vue&type=style&index=0&id=0b27d398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b27d398",
  null
  
)

export default component.exports